<script setup lang="ts">
import { VIcons } from '@/shared/ui'
import { useCabinetReports } from '@/pages/object/CabinetReports'
import { useSendReportFile } from './../model/api'

const model = useCabinetReports()
const { send } = useSendReportFile()

/**
 * Отправка запроса
 * @param item
 */
const save = (item: { id: unknown }) => {
  send({ ...model.filter, page: 1, per_page: 99999, download: item.id })
}
</script>

<template>
  <VTooltip :text="$t('itf.save_as_file')" location="top" activator="#save-button" />

  <VBtn id="save-button" v-bind="$attrs" color="warning">
    <VIcons type="save" />
  </VBtn>

  <VMenu activator="#save-button">
    <VList density="comfortable" @click:select="save">
      <VListItem value="xlsx">XLSX</VListItem>
      <VListItem value="csv">CSV</VListItem>
      <VListItem value="pdf">PDF</VListItem>
    </VList>
  </VMenu>
</template>
